import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    selector: String,
    inClass: String,
    outClass: String,
    markClass: String,
    threshold: { type: Number, default: 0 }
  };

  connect() {
    if (!('IntersectionObserver' in window)) return;

    this.target = document.querySelector(this.selectorValue);
    if (!this.target) return;

    // Persistent marker so scroll/sticky-based fallbacks can defer to this
    // element-based trigger (e.g. the nav's mobile logo->CTA swap gates on the
    // hero CTA here, so it should not also fire on plain scroll).
    if (this.hasMarkClassValue) this.target.classList.add(this.markClassValue);

    this.observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        const visible = entry.isIntersecting;
        if (this.hasInClassValue) {
          this.target.classList.toggle(this.inClassValue, visible);
        }
        if (this.hasOutClassValue) {
          this.target.classList.toggle(this.outClassValue, !visible);
        }
      }
    }, { threshold: this.thresholdValue });
    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer?.disconnect();
    if (this.hasMarkClassValue) this.target?.classList.remove(this.markClassValue);
  }
}
